const writeAReviewDevMode = false;
const writeAReviewModal = /** @type {HTMLElement}*/ (document.getElementById("royer-write-a-review-modal"));
const writeAReviewModalLoader = /** @type {HTMLElement}*/ (document.getElementById("write-a-review-modal-loader"));
const writeAReviewSuccessToast = /** @type {HTMLElement}*/ (document.getElementById("writeAReviewSuccessToast"));
const writeAReviewErrorToast = /** @type {HTMLElement}*/ (document.getElementById("writeAReviewErrorToast"));
const writeAReviewRatingWrapper = /** @type {HTMLElement}*/ (document.getElementById("review-rating-input-wrapper"));
const writeAReviewSubmitButton = /** @type {HTMLElement}*/ (document.querySelector('.review-submit-button'));
const writeAReviewPictureInput = /** @type {HTMLElement}*/ (document.getElementById('review-pictures'));
const writeAReviewPreviewContainer = /** @type {HTMLElement}*/ (document.getElementById('review-picture-preview'));

const writeAReviewCountrySelect = /** @type {HTMLSelectElement}*/ (document.getElementById('review-country'));
const writeAReviewRegionWrapper = /** @type {HTMLElement}*/ (document.querySelector('.review-region-wrapper'));
const writeAReviewRegionSelect = /** @type {HTMLSelectElement}*/ (document.getElementById('review-region'));

const writeAReviewRatingInputWrapper = /** @type {HTMLElement}*/ (writeAReviewRatingWrapper.closest(".review-input-wrapper"));
const writeAReviewRatingInput = /** @type {HTMLInputElement}*/ (writeAReviewRatingInputWrapper.querySelector(".review-input"));

/** @type {Bootstrap.Modal} */
let writeAReviewBootstrapModal;

/** @type {Bootstrap.Toast} */
let writeAReviewSuccessToastBootstrap;
/** @type {Bootstrap.Toast} */
let writeAReviewErrorToastBootstrap;

const writeAReviewsWebReviewApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebArtReviewApi, false);

updateWriteAReviewVisibleRegions();

document.addEventListener("DOMContentLoaded", (event) => {
  writeAReviewBootstrapModal = new bootstrap.Modal(writeAReviewModal);
  writeAReviewSuccessToastBootstrap = bootstrap.Toast.getOrCreateInstance(writeAReviewSuccessToast, { delay: 5000 });
  writeAReviewErrorToastBootstrap = bootstrap.Toast.getOrCreateInstance(writeAReviewErrorToast, { delay: 5000 });
});

writeAReviewRatingWrapper.addEventListener("mousemove", (ev) => {
  const totalWidth = writeAReviewRatingWrapper.clientWidth;
  const oneStarWidth = totalWidth / writeAReviewRatingWrapper.children.length;

  const rating = Math.min(Math.max(Math.ceil((ev.layerX - ev.offsetX - writeAReviewRatingWrapper.offsetLeft) / oneStarWidth) + 1, 1), 5);

  updateStars(rating);
});
writeAReviewRatingWrapper.addEventListener("mouseleave", (ev) => updateStars(parseInt(writeAReviewRatingInput.value) || 0));

writeAReviewRatingWrapper.addEventListener("click", (ev) => {
  const totalWidth = writeAReviewRatingWrapper.clientWidth;
  const oneStarWidth = totalWidth / writeAReviewRatingWrapper.children.length;

  const rating = Math.min(Math.max(Math.ceil((ev.layerX - ev.offsetX - writeAReviewRatingWrapper.offsetLeft) / oneStarWidth) + 1, 1), 5);

  writeAReviewRatingInput.value = rating.toString();
  removeErrors(writeAReviewRatingInput);
});

writeAReviewCountrySelect.addEventListener("change", () => updateWriteAReviewVisibleRegions());

// Submit button functionality
writeAReviewSubmitButton.addEventListener('click', async () => {
  const isValid = checkInputValidation();
  if (!isValid) return;

  //show the loader
  writeAReviewModalLoader.classList.add("show");

  const ratingInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-rating"));
  const titleInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-title"));
  const bodyInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-body"));
  const pictureInputs = /** @type {HTMLInputElement[]}*/ (Array.from(document.querySelectorAll(".review-picture")));
  const questionsInput = /** @type {HTMLInputElement[]}*/ (Array.from(document.getElementById("questions-section")?.querySelectorAll(".review-input-wrapper .review-input") ?? []));
  const firstNameInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-first-name"));
  const lastNameInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-last-name"));
  const emailInput = /** @type {HTMLInputElement}*/ (document.getElementById("review-email"));

  //Images are sent as the raw files (multipart IFormFile).
  /** @type {Blob[]} */
  const requestImages = [];
  pictureInputs.forEach(imgInput => requestImages.push(...imgInput.files ?? []));

  try {
    var response = await writeAReviewsWebReviewApi.webArtReviewCreateWebArtReview({
      displayLang: locale,
      websiteId: siteId,
      artId: product.dbId,
      curated: 0,//Ignored in backend
      featured: false,//Ignored in backend
      hidden: false,//Ignored in backend
      verifiedStatus: 1,//Ignored in backend
      source: 0,
      appName: "judge.me",
      appId: null,
      answers: /** @type {any} */ (questionsInput.map(input => JSON.stringify({
        questionId: parseInt(input.dataset.questionId ?? "-1"),
        questionOptionId: input.dataset.questionType == "SingleChoice" ? parseInt(input.value) : null,
        textValue: input.dataset.questionType == "PlainText" ? input.value : null,
      }))),
      images: requestImages,
      webCustomerId: 0,
      email: emailInput.value == "" ? null : emailInput.value,
      firstName: firstNameInput.value == "" ? null : firstNameInput.value,
      lastName: lastNameInput.value == "" ? null : lastNameInput.value,
      rating: parseInt(ratingInput.value),
      title: titleInput.value == "" ? null : titleInput.value,
      body: bodyInput.value == "" ? null : bodyInput.value,
      countryCode: writeAReviewCountrySelect.value == "" ? null : writeAReviewCountrySelect.value,
      regionCode: writeAReviewRegionSelect.value == "" ? null : writeAReviewRegionSelect.value,
    });

    //Hide the loader again
    writeAReviewModalLoader.classList.remove("show");

    if (response.value) {
      writeAReviewBootstrapModal.hide();
      writeAReviewSuccessToastBootstrap.show();
    }
    else {
      writeAReviewErrorToastBootstrap.show();
    }
  }
  catch (error) {
    //Hide the loader again
    writeAReviewModalLoader.classList.remove("show");
    writeAReviewErrorToastBootstrap.show();
    console.log(error)
  }
});

// Function to handle image uploads and show thumbnails
writeAReviewPictureInput.addEventListener('change', (event) => {
  // Clear previous thumbnails
  writeAReviewPreviewContainer.innerHTML = '';

  // Get the selected files
  const files = /** @type {HTMLInputElement}*/(event.target).files;

  //If no files are selected nothing to do
  if (!files) return;

  // Limit to 4 images
  const maxFiles = 4;
  const numFiles = Math.min(files.length, maxFiles);

  for (let i = 0; i < numFiles; i++) {
    const file = files[i];

    // Ensure it's an image file
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();

      // Create a thumbnail once the file is loaded
      reader.onload = function (e) {
        const img = document.createElement('img');
        img.src = e.target?.result?.toString() ?? "";
        img.alt = `Uploaded Image ${i + 1}`;
        img.className = 'review-thumbnail';
        writeAReviewPreviewContainer.appendChild(img);
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
    }
  }

  // Show a message if too many files are selected
  if (files.length > maxFiles) {
    alert(`You can only upload up to ${maxFiles} images.`);
  }
});

/**
 * 
 * @param {HTMLButtonElement} btnEl 
 * @returns 
 */
function questionChoiceClicked(btnEl) {
  const selectedClassname = "checked";
  const questionWrapper = /** @type {HTMLElement}*/ (btnEl.closest(".question-wrapper"));
  const isMultiple = questionWrapper.dataset.multiple == "true";

  //If it's already selected then do nothing
  if (btnEl.classList.contains(selectedClassname)) {
    //If it can have multiple value then deselect the option
    if (isMultiple) btnEl.classList.remove(selectedClassname);
    //Do nothing else
    return;
  }

  const selectInput = /** @type {HTMLSelectElement}*/ (questionWrapper.querySelector("select"));

  const questionOptionValue = btnEl.dataset.questionOptionValue;
  selectInput.value = questionOptionValue ?? "";
  removeErrors(selectInput);

  Array.from(questionWrapper.querySelectorAll("button")).forEach(btn => btn.classList.remove(selectedClassname));
  btnEl.classList.add(selectedClassname);
}

function checkInputValidation(showErrors = true) {
  /** @type {HTMLElement[]} */
  let invalidInputWrappers = [];

  /** @type {HTMLElement[]}*/(Array.from(writeAReviewModal.querySelectorAll(".review-input-wrapper"))).forEach(inputWrapper => {
    const input = /** @type {HTMLInputElement}*/ (inputWrapper.querySelector(".review-input"));
    const requiredInputErrorMsk = inputWrapper.querySelector("[data-required-error]");
    const emailFormatErrorMsk = inputWrapper.querySelector("[data-email-format-error]");
    let isValid = true;

    if (requiredInputErrorMsk && !input.value) {
      if (showErrors)
        requiredInputErrorMsk.classList.remove("invisible");
      isValid = false;
    }
    else if (emailFormatErrorMsk && (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)))) {
      if (showErrors) {
        if (requiredInputErrorMsk) requiredInputErrorMsk.classList.add("d-none")
        emailFormatErrorMsk.classList.remove("invisible");
        emailFormatErrorMsk.classList.remove("d-none");
      }
      isValid = false;
    }

    if (!isValid) invalidInputWrappers.push(inputWrapper);
  });

  //scrollToHighestElement is from royer-utilities-functions.js
  if (showErrors && invalidInputWrappers.length != 0) scrollToHighestElement(invalidInputWrappers);

  return invalidInputWrappers.length == 0;
}

/**
 * 
 * @param {HTMLInputElement | HTMLSelectElement} input 
 */
function removeErrors(input) {
  const inputWrapper = /** @type {HTMLElement}*/ (input.closest(".review-input-wrapper"));
  const requiredErrorMsg = inputWrapper.querySelector("[data-required-error]");
  const emailFormatErrorMsg = inputWrapper.querySelector("[data-email-format-error]");

  requiredErrorMsg?.classList.add("invisible");
  if (emailFormatErrorMsg) requiredErrorMsg?.classList.remove("d-none");

  if (requiredErrorMsg && emailFormatErrorMsg)
    emailFormatErrorMsg?.classList.add("d-none");
  else if (!requiredErrorMsg && emailFormatErrorMsg)
    emailFormatErrorMsg?.classList.add("invisible");
}

/**
 * 
 * @param {Number} rating 
 * @param {HTMLElement} wrapper 
 */
function updateStars(rating, wrapper = writeAReviewRatingWrapper) {
  for (let i = 0; i < rating; i++) {
    const star = wrapper.children[i];
    if (!star.classList.contains("full")) star.classList.add("full");
  }
  for (let i = rating; i < 5; i++) {
    const star = wrapper.children[i];
    if (star.classList.contains("full")) star.classList.remove("full");
  }
}

function updateWriteAReviewVisibleRegions() {
  const selectedCountryCode = writeAReviewCountrySelect.value;

  //Always unselect the region on country change
  writeAReviewRegionSelect.value = "";

  //Getting all the actual options (removing the default no answer option)
  const options = Array.from(writeAReviewRegionSelect.options).filter(option => option.value !== "");

  options.forEach(option => {
    if (option.dataset.country != selectedCountryCode) {
      option.classList.add("d-none");
      option.disabled = true;
    }
    else {
      option.classList.remove("d-none");
      option.disabled = false;
    }
  });

  //only show the correct label for the currently selected country
  Array.from(writeAReviewRegionWrapper.querySelectorAll("label")).forEach(label => {
    if (label.dataset.country == selectedCountryCode) label.classList.remove("d-none");
    else label.classList.add("d-none");
  });

  //If all the options are disabled then hide the region wrapper
  if (options.every(option => option.disabled)) writeAReviewRegionWrapper.classList.add("d-none");
  //If some options are visible then show the region wrapper
  else writeAReviewRegionWrapper.classList.remove("d-none");
}